export default "__VITE_ASSET__fn5DmyLn__"